import { WithClipboard } from '../../helpers/withClipboard.tsx'
import { InternalSecuritySummary } from './InternalSecuritySummary'

// @ts-ignore
export default WithClipboard(InternalSecuritySummary)
